module.exports = __webpack_public_path__ + "img/4.feed25e8.jpg";